module.exports = __webpack_public_path__ + "img/1_ava.7fc273b8.jpg";